import React from "react";
import { FormattedMessage } from "react-intl";

import { myGlobals, myUtilities } from "../../Utils";
import TrifectaCover from "../Common/TrifectaCover";

class PaymentFailed extends React.Component {
  renderPayFailed = () => {
    if (myGlobals.invalidRoutingNumberMessage) {
      return (
        <div className="centered-container">
         {myUtilities.accountSpecificLanguage("payment.status.failed.invalidRoutingNumber","Payment Failed, Invalid Routing Number")}
        </div>
      );
    } else {
      return (
        <div className="centered-container">
         {myUtilities.accountSpecificLanguage("payment.status.failed","Payment Failed, please try again later")}
        </div>
      );
    }
  }
  render() {
    return (myGlobals.currentTheme === "trifectaTheme.css" || myGlobals.currentTheme === 'modernUX.css')
      ? <TrifectaCover> {this.renderPayFailed()} </TrifectaCover>
      : this.renderPayFailed();
  }
}

export default PaymentFailed;
